module.exports = __webpack_public_path__ + "static/mobilenotification-purpose-do-9e71de934179547f997818de5fe77e5f.png";